import { PieChartModel, Coordinate } from '@leverege/ui-attributes-graphs';
function create(blueprint) {
  return {
    id: `${blueprint.alias}.PieChartModelConfigurer`,
    matches: {
      objectType: blueprint.alias
    },
    configure: (pieChartModel, objectType, context) => {
      let model = pieChartModel || PieChartModel.create();
      const coordinates = Coordinate.getCoordinatesFor(objectType);
      const attribute = PieChartModel.getAttribute(pieChartModel);
      if (!attribute && coordinates) {
        model = PieChartModel.setAttribute(pieChartModel, coordinates[0].create());
      }
      return model;
    }
  };
}
const BlueprintAnalyzer = {
  sort: 100,
  processBlueprints(molten, blueprints) {
    blueprints.forEach(b => {
      molten.addPlugin('PieChartModelConfigurer', create(b));
    });
  }
};
const HistoryResultConfigurer = blueprint => {
  return {
    id: `${blueprint.alias}.history.PieChartModelConfigurer`,
    matches: {
      objectType: blueprint.historyType
    },
    configure: (pieChartModel, objectType, context) => {
      let model = pieChartModel;
      const coordinates = Coordinate.getCoordinatesFor(objectType);
      const attribute = PieChartModel.getAttribute(pieChartModel);
      if (!attribute && coordinates) {
        model = PieChartModel.setAttribute(pieChartModel, coordinates[0].create());
      }
      return model;
    }
  };
};
const AggregationResultConfigurer = {
  id: 'aggResult.PieChartModelConfigurer',
  matches: {
    objectType: 'aggResult'
  },
  configure: (pieChartModel, objectType, context) => {
    let model = pieChartModel || PieChartModel.create();
    const valueCoordinate = Coordinate.getCoordinate(`${objectType}.value`, objectType);
    if (valueCoordinate) {
      model = PieChartModel.setAttribute(model, valueCoordinate.create());
    }
    return model;
  }
};
export default {
  create,
  BlueprintAnalyzer,
  HistoryResultConfigurer,
  AggregationResultConfigurer
};